import { useCallback } from 'react';

import { CreateSessionEntityContext, SessionEntityRequestHook } from 'modules/Session';
import { getDecodedAccessToken } from 'utils/token';

import { DEVELOPER } from '../constants';
import { getDeveloper } from '../services';
import { Developer } from '../types';
import { toDeveloper } from '../utils';

const useBuildDeveloperRequest: SessionEntityRequestHook<Developer> = (accessToken: string) => {
  const decodedToken = getDecodedAccessToken(accessToken);
  const callback = useCallback(() => getDeveloper(decodedToken?.sub as string).then(toDeveloper), [decodedToken]);

  const enabled = Boolean(decodedToken?.sub);

  return [callback, enabled];
};

const {
  useSessionEntityData,
  useMaybeSessionEntityData,
  useSessionEntityQuery,
  SessionEntityProvider,
  SafeSessionEntityProvider,
  QUERY_KEY,
} = CreateSessionEntityContext<Developer>(DEVELOPER, useBuildDeveloperRequest);

export const GET_DEVELOPER = QUERY_KEY;

export const useDeveloperData = useSessionEntityData;

export const useMaybeDeveloperData = useMaybeSessionEntityData;

export const useDeveloperQuery = useSessionEntityQuery;

export const DeveloperProvider = SessionEntityProvider;

export const SafeDeveloperProvider = SafeSessionEntityProvider;
